module.exports = __webpack_public_path__ + "static/media/team_dropdown_icon.949d2934.svg";